import { GzButtonWebComponent, GzDropdownWebComponent, GzFormFieldWebComponent } from 'apps/webcomponents/src/index.ui';
import { FormGroup } from 'apps/webcomponents/src/ui/gzForm/formGroup/form-group';
import { RequiredValidator } from 'apps/webcomponents/src/ui/gzForm/validators/required.validator';
import { translateFn } from 'apps/webcomponents/src/utils/translator.helper';
import { html, LitElement } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { Subscription } from 'rxjs';
import { styles } from '../view/styles';
import { FormGroupValue } from 'apps/webcomponents/src/ui/gzForm/formGroup/types/form-group-value';
import {
} from '@nirvana/shared/dtos/types/compliance-reports/gz-console';
import { FontSizes } from 'apps/webcomponents/src/types/common/types';

@customElement('compliance-download-report-form')
export class ComplianceDownloadReportFormWebComponent extends LitElement {
  @query('#complianceStandard')
  complianceStandard: GzFormFieldWebComponent<GzDropdownWebComponent, string | number | undefined>;

  @query('#format')
  format: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;

  @query('#submit')
  submitBtn: GzButtonWebComponent;

  @property({ type: Function, attribute: false, reflect: false })
  onSubmit: (value: FormGroupValue) => Promise<void>;

  @property({ type: Function, attribute: false, reflect: false })
  onCancel: () => void;

  @property({ type: String })
  selectedComplianceStandardFilter: string = 'CIS_v8';

  @state()
  private formGroup: FormGroup | null;

  @state()
  private subscription: Subscription;

  @property({ type: Array})
  complianceStandardOptions = [{
    value: '',
    title: '',
    id: 0,
  }];

  static get styles() {
    return styles;
  }

  firstUpdated(changedProperties: any) {
    super.firstUpdated(changedProperties);
    this.buildFormGroup();
  }

  private buildFormGroup() {
    [this.complianceStandard, this.format].forEach((field: GzFormFieldWebComponent) => {
      field.Validators = [RequiredValidator('Required field')];
    });

    this.complianceStandard.value = this.selectedComplianceStandardFilter; // CIS_V8
    this.format.value = this.formatOptions[0]?.value; // PDF

    this.formGroup = FormGroup.build({
      complianceStandard: this.complianceStandard,
      format: this.format,
    });

    this.subscription = this.formGroup.valid$.subscribe({
      next: valid => {
        this.submitBtn.disabled = !valid;
      },
    });
  }

  private async handleFormSubmit() {
    if (!this.formGroup) {
      return;
    }

    this.submitBtn.setLoadingState(true);

    await this.onSubmit(this.formGroup.value);

    this.submitBtn.setLoadingState(false);

    this.formGroup.unsubscribe();
    this.subscription.unsubscribe();
  }

  private formatOptions = [
    {
      id: 0,
      title: 'PDF',
      value: 'PDF',
    },
    {
      id: 1,
      title: 'XLSX',
      value: 'XLSX',
    },
  ];

  render() {
    return html`
      <div class="d-flex flex-column">
        <gz-text class="mb-2" fontSize="${FontSizes.HEADING_6}"
          >${translateFn(
            'A compliance report will be generated containing the details currently displayed on the page.'
          )}</gz-text
        >
        <gz-form-field label="${translateFn('Compliance standard')}" id="complianceStandard">
          <gz-dropdown gz-form-input options="${JSON.stringify(this.complianceStandardOptions)}"></gz-dropdown>
        </gz-form-field>
        <gz-form-field label="${translateFn('Format')}" id="format">
          <gz-dropdown gz-form-input options="${JSON.stringify(this.formatOptions)}"></gz-dropdown>
        </gz-form-field>
        <div class="d-flex justify-space-between mt-4">
          <gz-button id="submit" @click="${this.handleFormSubmit}">${translateFn('Download')}</gz-button>
          <gz-button id="cancel" type="outline" color="secondary" @click="${this.onCancel}"
            >${translateFn('Cancel')}</gz-button
          >
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'compliance-download-report-form': ComplianceDownloadReportFormWebComponent;
  }
}
